export default __webpack_public_path__ + "static/media/b_wdt_c_3.45919fd5.mp3";